import styled from "styled-components";
import { useEffect, useState } from "react";
import { listConveyor } from "../../../modules/conveyor/conveyorAPI";
import Button from "../../common/Button";
import AskCopyFromOthersModal from "./AskCopyFromOthersModal";
import { useSelector } from "react-redux";


const CopyFromOhtersButton = ({ setInput }) => {    // PowerCalculationJIS에서 보낸 props임. 
    const project = useSelector(state => state.project.project);
    const projectId = project?._id;

    const [modal, setModal] = useState(false);
    const [conveyors, setConveyors] = useState([]);

    const handleSelectOthers = () => {
        setModal(true);
    }


    useEffect(() => {
        const fetchConveyors = async (projectId) => {
            try {
                const response = await listConveyor({ projectId }); 
                setConveyors(response.data);
            } catch (err) {
                console.error(err);
            }
        }

        fetchConveyors(projectId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // 컴포넌트가 처음 마운트될 때만 실행


    /* 아래와 같이 비동기 함수를 직접적으로 호출하면 promise로 반환된 결과를 변수에 할당했기 때문에 컴포넌트에서 직접 사용할 수 없다. useEffect와 useState를 사용하여 상태관리하여야 한다. */

    /** 아래 코드는 아래의 이유로 사용해서는 안된다. 
     *  아래 코드는 비동기 함수를 호출했다. 비동기 함수를 호출했다는 것은 그 결과를 기다리는 동안 Promise 객체를 반환하기 때문에 
     *  그 아래 console.log가 먼저 실행이 된다. 이 때 conveyors에는 promise 객체가 저장되어 있다.
     *  시간이 지나서 비동기 함수에서 제대로 된 값이 전달되어도 이미 되돌아오는 프로세스가 없기 때문에 에러가 발생하고 끝난다.
     *  이 때 useState를 이용하여 promise를 관리하면 promise가 나중에 바뀔 때 그 상태를 업데이트하여 본 컴포넌트가 제대로 작동하게 된다.
     *  그래서 useEffect와 useState를 사용해야 하는 것이다.
     */
    // const conveyors = getConveyors(projectId);
    // console.log('conveyors : ', conveyors);
    


    if (!conveyors) {
        return;
    }


    const onSelect = (conveyor) => {
        // 해당 컨베이어를 리덕스 conveyorWrite에 쓰고 창을 닫는다.
        const { body: { input } } = conveyor;

        // dispatch(copyConveyor(input));
        // 이미 PowerCalculationJIS 컴포넌트가 마운트된 이후이기 때문에 리덕스를 수정해도 반영되지 않는다. 
        // useState의 setInput을 사용화면 된다.
        setInput(input);

        setModal(false);
    }

    const onCancel = () => {
        setModal(false);
    }

    const onConfirm = () => {
        setModal(false);
    }


    return (
        <CopyFromOthersButtonBlock>
            <Button cyan onClick={handleSelectOthers}>Copy from Others</Button>
            <AskCopyFromOthersModal visible={modal} onSelect={onSelect} onConfirm={onConfirm} onCancel={onCancel} conveyors={conveyors} />
        </CopyFromOthersButtonBlock>
    )
}

export default CopyFromOhtersButton;

const CopyFromOthersButtonBlock = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-right: 5.7rem;
    margin-bottom: 1rem;
`;